import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["education", "empty"];
import React, { Fragment, useMemo } from "react";
import { formatDatesWithCurrent } from "../../helpers";
export var Education = function Education(_ref) {
  var education = _ref.education,
      empty = _ref.empty,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var filteredEducation = useMemo(function () {
    return education.filter(function (ed) {
      return !ed.omit;
    });
  }, [education]);
  if (!filteredEducation.length && !empty) return null;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: "education"
  }, otherProps), /*#__PURE__*/React.createElement("h2", null, "Education"), empty && /*#__PURE__*/React.createElement("p", null, "Click here to add your education"), /*#__PURE__*/React.createElement("dl", null, filteredEducation.map(function (_ref2) {
    var institute = _ref2.institute,
        focus = _ref2.focus,
        location = _ref2.location,
        date_range = _ref2.date_range,
        quick_details = _ref2.quick_details,
        graduated = _ref2.graduated,
        completion = _ref2.completion,
        is_current = _ref2.is_current;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "".concat(institute, "/").concat(focus, "/").concat(location, "/").concat(date_range)
    }, false && /*#__PURE__*/React.createElement("dt", null, /*#__PURE__*/React.createElement("span", {
      "data-what": "institute"
    }, institute), /*#__PURE__*/React.createElement("span", {
      "data-what": "focus"
    }, focus)), /*#__PURE__*/React.createElement("dd", {
      className: "quiet"
    }, /*#__PURE__*/React.createElement("section", {
      className: "summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "education-institute"
    }, institute), location && /*#__PURE__*/React.createElement("div", {
      className: "education-location"
    }, location), /*#__PURE__*/React.createElement("div", {
      className: "education-focus"
    }, focus), /*#__PURE__*/React.createElement("div", {
      className: "education-dates"
    }, formatDatesWithCurrent({
      date_range: date_range,
      is_current: is_current
    })), (completion || graduated) && /*#__PURE__*/React.createElement("div", {
      className: "education-completion"
    }, completion || graduated && "Graduated")), /*#__PURE__*/React.createElement("section", {
      className: "details quick"
    }, /*#__PURE__*/React.createElement("p", null, quick_details))));
  })));
};